import { render } from "./Emails.vue?vue&type=template&id=00d81b6c&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"

import "./Emails.vue?vue&type=style&index=0&id=00d81b6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d81b6c"]])

export default __exports__